const LeadIcon = ({ className, onClick, width = 16, height = 16 }) => (
  <svg
    width={width}
    className={className}
    onClick={onClick}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20" r="20" fill="#CEFBFA" />
    <path
      d="M31.667 20a11.667 11.667 0 11-23.335 0 11.667 11.667 0 0123.335 0z"
      fill="#fff"
      stroke="#1F1F1F"
      strokeWidth="1.5"
    />
    <path
      d="M18.577 16.705C19.21 15.567 19.527 15 20 15c.473 0 .79.567 1.423 1.705l.164.293c.18.324.27.484.41.59.141.107.316.147.666.225l.317.074c1.23.278 1.845.416 1.992.886.146.47-.274.962-1.112 1.942l-.217.253c-.238.279-.358.417-.411.59-.054.174-.035.359 0 .73l.033.339c.127 1.308.19 1.963-.192 2.253-.383.29-.96.025-2.111-.505l-.297-.137c-.328-.15-.492-.225-.665-.225-.173 0-.337.075-.665.225l-.297.137c-1.151.532-1.728.795-2.111.505-.384-.29-.319-.945-.192-2.253l.033-.339c.035-.371.054-.556 0-.73-.053-.173-.173-.311-.411-.59l-.217-.253c-.838-.98-1.258-1.47-1.112-1.942.147-.47.762-.608 1.992-.886l.317-.074c.35-.078.525-.116.666-.225.14-.106.23-.266.41-.59l.164-.293z"
      fill="#CEFBFA"
      stroke="#1F1F1F"
      strokeWidth="1.5"
    />
    <path
      d="M9.307 25.526l-4.32 4.778c-.9.932-1.35 1.399-1.507 1.794-.355.898-.05 1.896.722 2.37.34.206.951.271 2.175.401.691.074 1.036.109 1.325.22a2.383 2.383 0 011.391 1.44c.107.3.142.657.214 1.374.123 1.266.186 1.9.386 2.25.457.8 1.422 1.113 2.289.746.383-.16.833-.625 1.733-1.558L20 32.833l6.285 6.508c.9.933 1.35 1.398 1.733 1.558.867.367 1.832.054 2.289-.746.2-.35.261-.984.386-2.25.072-.717.107-1.074.214-1.374a2.39 2.39 0 011.391-1.44c.289-.111.634-.146 1.325-.22 1.224-.13 1.835-.195 2.175-.401.772-.474 1.077-1.472.722-2.37-.157-.395-.607-.862-1.507-1.794l-4.706-4.778"
      stroke="#1F1F1F"
      strokeWidth="1.5"
    />
  </svg>
);

export default LeadIcon;
